
import { FIELD_STATUS } from '../../../reducers/status';
import {
    getPersonalDetailsForm,

} from '../../../selectors/digiLifeLoanProtection/personalDetails';
import { DLP_PERSONAL_DETAILS_SCROLL_ID } from '../status';
import { transitionScrolling } from '../../../actions/digiLifeLoanProtection/scrolling';
import { setClaimentDetailsValue, transitionClaimentDetails } from '../../../actions/sizotsaFuneralClaim/claimentDetails';
import { getClaimentDetailsValidations } from '../../../selectors/sizotsaFuneralClaim/claimentDetails';

export const claimentDetailsRules = (store, next, action) => {
    const result = next(action);

    const isValid = isClaimentDetailsValid(store);
    store.dispatch(isValid ? transitionClaimentDetails.formValid() : transitionClaimentDetails.formInvalid());

    return result;
};

// Personal Information
const isClaimentDetailsValid = (store) => {
    const state = store.getState();
    const isValid = (field) => {
        return field && field.status === FIELD_STATUS.VALID;
    };
    const claimentDetailsValidation = getClaimentDetailsValidations(state);
    const claimentDetailsFormFields = [...Object.values(claimentDetailsValidation)];

    const claimentDetailsValid = claimentDetailsFormFields.every(isValid);
    return claimentDetailsValid;
};

export const performClaimentDetailsValidation = (store) => {
    const createDispatchHandler = (fieldType, value, displayValue) => {
        store.dispatch(setClaimentDetailsValue({ fieldType, value, displayValue }));
    };
    const state = store.getState();

    const claimentDetailsFormFields = getClaimentDetailsValidations(state);

    Object.keys(claimentDetailsFormFields).map((property) => {
        const { value, displayValue } = claimentDetailsFormFields[property];
        createDispatchHandler(property, value, displayValue);
    });
    setScrollError(store);
};

export const setScrollError = (store) => {
    const state = store.getState();
    const fieldKeyArr = DLP_PERSONAL_DETAILS_SCROLL_ID;
    const personalDetailsForm = getPersonalDetailsForm(state);
    const firstErrorField = fieldKeyArr.find(
        (fieldKey) => fieldKey in personalDetailsForm && personalDetailsForm[fieldKey].error
    );

    store.dispatch(transitionScrolling.scrollToId(firstErrorField));
};
